import firebase from 'firebase/app';
import 'firebase/storage'

export const getSoundDownloadUrl = async (soundUrl) => {
    const soundDownloadUrl = await firebase.storage().refFromURL(soundUrl).getDownloadURL()
    return soundDownloadUrl;
}

export const downloadAllSounds = async (soundUrls) => {
    await Promise.all(soundUrls.map(async (soundUrl) => {
        const soundDownloadUrl = await firebase.storage().refFromURL(soundUrl).getDownloadURL()
        console.log(soundDownloadUrl);
    }))
}

export const playSound = async (soundUrl) => {
    const soundDownloadUrl = await firebase.storage().refFromURL(soundUrl).getDownloadURL()
    console.log(soundDownloadUrl);
    new Audio(soundDownloadUrl).play()
}